<template>
  <div>
    <v-form>
      <v-container class="pl-0">
        <div>
          <v-row>
            <v-col class="mt-2" cols="6" md="6">
              <v-select flat background-color="#F6F8FC" label="Modality" :items="ModalityList"
                v-model="selectedTestimonial.Modalities" hide-details solo class="feild mt-2"></v-select>
            </v-col>
            <v-col class="mt-2" cols="6" md="6">
              <v-select flat hide-details background-color="#F6F8FC" label="Language" :items="LanguageList"
                persistent-hint v-model="selectedTestimonial.Languages" solo class="feild mt-2"></v-select>
            </v-col>
          </v-row>
        </div>
        <div class="mt-4 mb-4">
                              <span class="txt_style_heading mt-4 mb-3">Testimonial</span>

                              <v-textarea class="text_feild mt-4" outlined name="input-7-4" label=""
                                v-model="selectedTestimonial.Testimonials"></v-textarea>
                            </div>
       
      </v-container>
    </v-form>
  </div>
</template>
<script>
export default {
  name: "edittestimonailcomponent", 
  props: ["selectedTestimonial"],
  data() {
    return {
      ModalityList: [
        "BodyTalk",
        "BreakThrough",
        "FreeFall",
        "MindScape",
        "Access",
        "BodyTalk for Animals",
      ],
       LanguageList: [
        "English",
        "German",
        "Portuguese ",
        "French",
        "Spanish ",
        "Italian",
        "Chinese",
        "Russian",
        "Filipino",
        "Japanese"
      ],
      };
  },
};
</script>

<style scoped>
.feild {
  background-color: #f6f8fc;
  border: 1px solid #dee3ef;
  border-radius: 6px;

}
</style>
